import { Box, IconButton, Typography } from "@mui/material";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { Component } from "../../../../types/component";
import { formatAssemblyCellValue } from "./airframeAssemblyGridColumns";

type Props = {
  component: Component | undefined;
  onDetach: (componentId: string, airframeId?: string, slotId?: string) => void;
  canDetach: boolean;
};

export function AirframeAssemblyCell({ component, onDetach, canDetach }: Props) {
  const displayValue = formatAssemblyCellValue(component);

  if (!component) {
    return (
      <Typography component="span" sx={{ color: "#888" }}>
        {displayValue}
      </Typography>
    );
  }

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, minWidth: 0 }}>
      <Typography
        component="span"
        sx={{
          color: "#fff",
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        title={displayValue}
      >
        {displayValue}
      </Typography>
      {canDetach && (
        <IconButton
          size="small"
          aria-label="Detach assembly"
          title="Detach assembly"
          sx={{ color: "hsl(19 101% 51% / 1)", flexShrink: 0, p: 0.25 }}
          onClick={(event) => {
            event.stopPropagation();
            onDetach(component.id, component.airframeId, component.slotId);
          }}
        >
          <LinkOffIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
